/**
 * @generated SignedSource<<551472efd8c5cec31961ddb6c7ca75b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MediaType = "EXTERNAL" | "INTERNAL";
import { FragmentRefs } from "relay-runtime";
export type MediaThumb_media$data = {
  readonly externalUrl: string | null;
  readonly src: string | null;
  readonly type: MediaType;
  readonly " $fragmentType": "MediaThumb_media";
};
export type MediaThumb_media$key = {
  readonly " $data"?: MediaThumb_media$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaThumb_media">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaThumb_media",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "S120X120"
        }
      ],
      "kind": "ScalarField",
      "name": "externalUrl",
      "storageKey": "externalUrl(size:\"S120X120\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "w262"
        }
      ],
      "kind": "ScalarField",
      "name": "src",
      "storageKey": "src(size:\"w262\")"
    }
  ],
  "type": "Media",
  "abstractKey": null
};

(node as any).hash = "1344c04a2a51a88efe6ccf48146df727";

export default node;
